import { useQuestionizerStore } from "../types/state";
import { Button } from "./button.tsx";
import Errors from "./errors";
import { useState } from "react";

export default function StepButtons(){
  const step = useQuestionizerStore((state) => state.step);
  const stepsCount = useQuestionizerStore((state) => state.stepsCount());
  const incrementStep = useQuestionizerStore((state) => state.incrementStep);
  const decrementStep = useQuestionizerStore((state) => state.decrementStep);
  const isCurrentStepValid = useQuestionizerStore((state) => state.isCurrentStepValid());
  const isInputTypeExistInPage = useQuestionizerStore((state) => state.isInputTypeExistInPage);
  const formWasMailed = useQuestionizerStore((state) => state.form_was_mailed);
  const config = useQuestionizerStore((state) => state.config);
  const currentSections = config?.layout[step].sections;
  const nextSections = config?.layout[step+1]?.sections;
  const lastSections = config?.layout[stepsCount-1]?.sections;
  const use_doi = config?.use_doi ?? false;
  const doi_confirm = useQuestionizerStore((state) => state.doi_confirm);
  const doi_wait_confirm = useQuestionizerStore((state) => state.doi_wait_confirm);
  const translation = useQuestionizerStore((state) => state.translation);
 
 const go_next = () => {
          document.querySelector(".top_section")?.focus();
          incrementStep();
        };
        
  var showButtonKontakt = false;
  if(nextSections && (nextSections == lastSections) && isInputTypeExistInPage(lastSections ?? [],"form") ){
	showButtonKontakt = true;
  }

  return <div>	  
	  <div className='step_buttons'>
		{ step > 0 ? <Button label={translation.labels["step-btn--zurueck"] || "Zurück"}
        icon_left_class="icon-inline--left icon-left--white"
        className="step_buttons__back"
        onClick={ decrementStep }
      />
    : <div></div>}
		<Errors></Errors>
		
		{(step < (stepsCount - 1) && !showButtonKontakt) ? (
		  <div
			className={
			  "step_buttons__button btn step_buttons__next " +
			  (isCurrentStepValid ? "" : "btn--disabled")
			}
			role="button"
			tabIndex={0}
			onClick={ (_) => incrementStep() }
			onKeyUp={ (event) => {
				if ((event.code != " ")  && (event.code != "Enter")) { return } 
				incrementStep();
			  }}
		  >
			<span>{translation.labels["step-btn--weiter"] || "Weiter"}</span>
			<div className="step_buttons__icon icon-inline--right icon-right--white pl-4"></div>
		  </div>
		) : (
		  <div></div>
		)}		
			
		{ currentSections && isInputTypeExistInPage(currentSections,"result") && <PrintButton /> }
		{ currentSections && (currentSections == lastSections) && isInputTypeExistInPage(currentSections,"form")  && !formWasMailed &&  <SendEmailButton /> }
		{ currentSections && isInputTypeExistInPage(currentSections,"form")  && use_doi && !doi_confirm && doi_wait_confirm && <DoiButton /> }
		
	  </div>
	  <div className='pt-4'/>
	  <div className='pt-4'>
	  		{ showButtonKontakt && <Button label={translation.labels[config?.text_btn_contact] || config?.text_btn_contact} 
                 icon_left_class="step_buttons__icon  pl-4"
                 className="btn-full"
                 onClick={go_next}
          />}
	  </div>
   </div>
}

function PrintButton(){
  const include_in_print = useQuestionizerStore((state) => state.include_in_print);
  const openPrintView = useQuestionizerStore((state) => state.openPrintView);
  const translation = useQuestionizerStore((state) => state.translation);

  let print_list_empty = Object.keys(include_in_print).filter(key => include_in_print[key]).length > 0;

  return <Button label={translation.labels["step-btn--drucken"] || "Auswahl Anzeigen / Drucken"}
                 disabled={!print_list_empty}
                 icon_left_class="btn__icon_print"
                 className="btn--print step_buttons__next"
                 onClick={ () => openPrintView(undefined) }
          />
  }
  
function SendEmailButton(){
  const sendMail = useQuestionizerStore((state) => state.sendMail);
  const translation = useQuestionizerStore((state) => state.translation);
  
  return <div className={"step_buttons__button btn--print step_buttons__next btn"} 
              onClick={ (_) => sendMail() }>
                <span>{translation.labels["step-btn--senden"] || "Senden"}</span>
            </div>;
}

function DoiButton() {
  const sendDoiMail = useQuestionizerStore((state) => state.sendDoiMail);
  const setDoiWaitConfirm = useQuestionizerStore((state) => state.setDoiWaitConfirm);
  const translation = useQuestionizerStore((state) => state.translation);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    setSuccess(false);
    try {
      await sendDoiMail();
      setSuccess(true);
    } catch (err) {
      alert("Fehler beim Senden der E-Mail.");
    }
    setLoading(false);
  };

  return (
    <div
      id="doi-request"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="bg-white p-6 rounded-2xl max-w-lg w-full text-center shadow-xl">
       <h2 className="text-lg font-semibold">
		  {translation.labels["step-doi--titel"] || "Bestätigungs-E-Mail wurde gesendet."}
		</h2>
		<div className="mb-6">
		  {translation.labels["step-doi--beschreibung"] || "Bitte klicken Sie auf den Link in der E-Mail, um fortzufahren. Falls Sie keine E-Mail erhalten haben, können Sie den Button unten nutzen, um die E-Mail erneut zu senden."}
		  {success && <div className="text-green-600 mt-2">
			{translation.labels["step-doi--erfolg"] || "E-Mail erfolgreich gesendet."}
		  </div>}
		</div>
        <button
          className="step_buttons__button btn--print step_buttons__next btn mx-auto"
          onClick={handleSend}
          disabled={loading}
        >
        <span>{loading 
		  ? (translation.labels["step-doi--senden_laeuft"] || "Wird gesendet...") 
		  : (translation.labels["step-doi--senden_nochmal"] || "E-Mail nochmal senden")
		}</span>
        </button>
		<a className="doi-cancel" onClick={() => setDoiWaitConfirm(false)}>
		  {translation.labels["step-doi--abbrechen"] || "Abbrechen"}
		</a>
      </div>
    </div>
  );
}